<template>
  <el-container>
    <el-header class="header">
      <el-row type="flex" align="middle">
        <el-col :span="6">
          <a href="#/leisure">
            <img v-if="theme && theme.iconFile" :src="theme.iconFile" class="logo" />
          </a>
          <h3>{{$utils.sys.name}}</h3>
        </el-col>
        <el-col :span="18" class="right">
          <el-popover v-if="user" placement="bottom" title="" width="200" trigger="click" v-model="showProfile">
            <profile :user="user" switchDept />
            <el-link style="color:white" slot="reference" >{{user.tenantName}}：{{ user.name }}</el-link>
          </el-popover>
          <el-button v-if="!loading" type="danger" icon="el-icon-switch-button" size="mini" circle @click="logout" class="left-pad"></el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main style="padding: 1px">
      <el-container class="f-h">
        <el-aside v-if="!loading" width="auto">
          <el-menu :collapse="isCollapse" :unique-opened="true" :default-active="$route.name" class="f-h" router>
            <div style="margin-top: 0.5rem">
              <el-button type="primary" icon="el-icon-arrow-right" @click="collapseToggle" v-if="isCollapse" circle plain size="mini"></el-button>
              <el-button type="primary" icon="el-icon-arrow-left" @click="collapseToggle" v-else circle plain size="mini"></el-button>
            </div>
            <!-- <el-menu-item index="reg" title="挂号" v-if="permission.registration_registry_query">
              <i class="el-icon-s-ticket"></i>
              <span>挂号</span>
            </el-menu-item>
            <el-menu-item index="charge" title="收费" v-if="permission.registration_charge_query">
              <i class="el-icon-s-finance"></i>
              <span>收费</span>
            </el-menu-item>
            <el-menu-item index="app" title="预约" v-if="permission.registration_appoint_query">
              <i class="el-icon-phone"></i>
              <span>预约</span>
            </el-menu-item>
            <el-menu-item index="patient" title="患者" v-if="permission.registration_patient_query">
              <i class="el-icon-s-custom"></i>
              <span>患者</span>
            </el-menu-item>
            <el-menu-item index="pool" title="号池" v-if="permission.registration_pool_query">
              <i class="el-icon-s-grid"></i>
              <span>号池</span>
            </el-menu-item>
            <el-menu-item index="type" title="号别" v-if="permission.registration_type_query">
              <i class="el-icon-s-flag"></i>
              <span>号别</span>
            </el-menu-item>
            <el-menu-item index="channel" title="渠道" v-if="permission.registration_channel_query">
              <i class="el-icon-s-shop"></i>
              <span>渠道</span>
            </el-menu-item>
            <el-menu-item index="invoice" title="发票" v-if="permission.registration_invoice_query">
              <i class="el-icon-s-check"></i>
              <span>发票</span>
            </el-menu-item>
            <el-menu-item index="triage" title="分诊" v-if="permission.registration_triage_query">
              <i class="el-icon-s-promotion"></i>
              <span>分诊</span>
            </el-menu-item> -->
            <el-menu-item v-for="item in menus.menuList" :index="item.indexFileName" :key="item.id">
              <i :class="item.icon"></i>
              <span>{{item.name}}</span>
            </el-menu-item>

            <el-menu-item  index="callback" >
              <i class="el-icon-refresh-left"></i>
              <span>{{'回访'}}</span>
            </el-menu-item>

            <el-submenu v-for="firstItem in menus.firstMenu" :key="firstItem.id" :index="firstItem.indexFileName">
              <template slot="title">
                  <i :class="firstItem.icon"></i>
                  <span>{{firstItem.name}}</span>
              </template>
              <el-menu-item v-for="item in menus.firstMenuList.filter(p => p.firstMenuId == firstItem.id)" :index="item.indexFileName" :key="item.id" :title="item.memo" :class="item.menuClass">
                  <span>{{item.name}}</span>
              </el-menu-item>
            </el-submenu>
            <!-- <el-menu-item index="settle" title="日结" v-if="permission.registration_triage_query">
              <i class="el-icon-s-order"></i>
              <span>日结</span>
            </el-menu-item>
            <el-menu-item index="emergency" title="急诊" v-if="permission.registration_triage_query">
              <i class="el-icon-s-finance"></i>
              <span>预检</span>
            </el-menu-item> -->
            <!-- TODO 测试用页面，正式使用需删除该路径 -->
            <!-- <el-menu-item index="medcom" title="医保组件">
              <i class="el-icon-s-finance"></i>
              <span>医保</span>
            </el-menu-item> -->
          </el-menu>
        </el-aside>
        <el-container class="f-h">
          <el-main>
            <router-view/>
          </el-main>
          <el-footer style="height:3rem;">
            <h5 :title="`系统版本: ${$utils.sys.version}`" style="margin:1rem;">
                {{theme.copyright || $utils.sys.copyright}}
                <el-link href="http://beian.miit.gov.cn" target="_blank">{{theme.icp || $utils.sys.icp}}</el-link>
            </h5>
          </el-footer>
        </el-container>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import {
    mapGetters
} from "vuex";
// import cfg from "@/common/cfg";
import api from "@/common/api";
export default {
    name: "App",
    components: {
        profile: () => import("@/components/_com/profile")
    },
    data() {
        return {
            isCollapse: false,
            showProfile: false,
            loading: false
        };
    },
    computed: {
        ...mapGetters(["user", "permission", "theme", "menus", "setting"])
    },
    async mounted() {
        let _this = this;
        try {
            if (this.permission.isEmpty) {
                this.loading = true
                const ps = await api.getPermission();
                if (!ps.length) {
                    _this.$utils.goErr(cfg.errs.NeedPromission);
                    throw new Error("抱歉，您没有权限访问此系统！");
                }
                _this.$store.commit("permission", ps);
                _this.loading = false
            }
            if (!this.user) {
                const usr = await api.getCurrentUser();
                _this.$store.commit("user", usr);
            }
            if (this.menus.isEmpty) {
                const ms = await api.getMyMenus({
                  clientId: cfg.sys.code,
                  staffId: _this.user.id,
                });
                _this.$store.commit("menus", ms);
            }
            const st = await api.getSetting({
                sysCode: cfg.sys.code
            });
            _this.$store.commit("setting", st);
            if (this.setting.ifMedicallnsurance) {
              _this.$store.dispatch("initMed")
            }
        } catch (err) {
            if (err) {
                _this.$message.error(err.message || err);
            }
        }
    },
    methods: {
        logout() {
            this.$utils.logout();
        },
        collapseToggle() {
            this.isCollapse = !this.isCollapse;
        }
    }
};
</script>
<style scoped>
.header {
  background-color:dimgray;/* GoldenRod; #199ed8;  */
  color: white;
  text-align: left;
  font-family: "Microsoft YaHei", "Youyuan", "黑体", "宋体", sans-serif;
  box-shadow: 0 0 5px black;
}
.logo {
  float: left;
  height: 48px;
  margin: 8px 20px 8px 6px;
}
</style>
